import { selector } from '@/lib/selectors';
import type { PaymentProvidersList, PaySettingsStateRecord } from '@/domain/paySettings/types';

// The listed payment providers of the company in scope (DPM-846: Open Finance only). A leaf selector, so the env
// pay-permission selectors can compose from it without importing the paySettings selector module.
export const paymentProvidersLeafSelector = selector<unknown, PaymentProvidersList>(
  (state: { paySettings: PaySettingsStateRecord }) => state.paySettings,
  (p: PaySettingsStateRecord) => p.providers,
);
